import * as React from "react";
import { forwardRef } from "react";
const DisabilityEquippedIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M6.071 9.821a.75.75 0 0 1 .917 1.189 5.01 5.01 0 0 0-1.951 3.744 5.023 5.023 0 0 0 9.029 3.254.75.75 0 1 1 1.198.902 6.521 6.521 0 0 1-11.726-4.225A6.51 6.51 0 0 1 6.07 9.822z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.941 2.909a2.702 2.702 0 1 1-.882 5.254l.258 1.646h4.179l.076.004a.75.75 0 0 1 0 1.492l-.076.004H10.55l.267 1.706h4.654a.75.75 0 0 1 .682.438l2.053 4.468 1.824-.86.071-.029a.75.75 0 0 1 .569 1.386l-2.509 1.185a.75.75 0 0 1-1.002-.365l-2.169-4.721h-4.816a.75.75 0 0 1-.741-.634L8.248 6.284l-.008-.076a.776.776 0 0 1 .025-.232A2.701 2.701 0 0 1 10.94 2.91zm0 1.5a1.2 1.2 0 1 0 0 2.403 1.202 1.202 0 0 0 0-2.403z"
}));
const ForwardRef = forwardRef(DisabilityEquippedIcon);
export default ForwardRef;